import Button from 'components/button';
import { FiSearch } from 'react-icons/fi';
import titleShape from 'assets/images/icons/steps.png';
import PageHeaderStyleWrapper from './PageHeader.style';
import { useTranslation } from 'react-i18next';

const PageHeader = ({ currentPage, pageTitle }) => {
  const { t } = useTranslation();
  return (
    <PageHeaderStyleWrapper>
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-5">
            <div className="breadcrumb_area">
              <div className="breadcrumb_menu">
                <>
                  <a href="# ">{t('pageHeader.home')}</a> <span>.</span>{' '}
                  {currentPage && currentPage}
                </>
                <img
                  className="heading_shape"
                  src={titleShape}
                  alt="bithu nft heading shape"
                />
              </div>
              <h2 className="breadcrumb_title text-uppercase">
                {pageTitle && pageTitle}
              </h2>
            </div>
          </div>

          {/* <div className="col-lg-7">
            <div className="breadcrumb_form">
              <form onSubmit={(e) => e.preventDefault()}>
                <input
                  type="text"
                  id="Search"
                  name="search"
                  placeholder={t('pageHeader.searchPlaceholder')}
                />
                <button>
                  <FiSearch />
                </button>
              </form>
              <Button sm variant="dark" href="# ">
                {t('pageHeader.leaderboard')}
              </Button>
            </div>
          </div> */}
        </div>
      </div>
    </PageHeaderStyleWrapper>
  );
};

export default PageHeader;
